<template>
  <section class="main">
    <h1 class="intro">{{ $t("DEVICE_UPDATES_TITLE") }}</h1>
    <div class="row">
      <div class="apps">
        <loader v-if="pending" />
        <app
          :isUpdatable="true"
          v-for="app in apps"
          :key="app.trackid"
          :app="app"
        />
      </div>
      <div class="warning g-text">
        {{ $t("APPS_APPSTORE_OTA_CANNOT_BE_UPDATED") }}
      </div>
    </div>
  </section>
</template>

<script>
import App from '@/components/App';
import Loader from '@/components/Loader';

export default {
  components: { App, Loader },
  data() {
    return {
      pending: true,
      apps: [],
    };
  },
  computed: {
    title() {
      return this.$t('DEVICE_UPDATES_TITLE');
    },
  },
  created() {
    this.$api.getUpdates()
      .then((apps) => {
        this.apps = apps;
      })
      .finally(() => { this.pending = false; });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.main {
  display: block;
  flex-grow: 1;
}

.row {
  display: flex;
  align-items: flex-start;
}

.warning {
  flex: 0 0 200px;
  margin-left: 25px;
  background: #fbfbfb;
  border-radius: 8px;
  padding: 8px;

  @include notebook {
    display: none;
  }
}

.apps {
  flex-grow: 1;
}
</style>
